import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { DatasheetPageInitialData } from "./datasheetPageInitialData";

export const datasheetPageQueryOptions = (productDesignation: string) =>
  queryOptions({
    queryKey: pageDataKeys.page(`datasheet/${productDesignation}`),
    queryFn: () =>
      fetchOccPageData<PageInitialDataResult<DatasheetPageInitialData>>(`/page-data/datasheet/${productDesignation}`),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
